import type { Styles } from '@adornis/ass/style.js';
import { setGlobalStyle } from '@adornis/chemistry/elements/theming/global-style';
import { DigitaleHeldenFont } from '@adornis/digitale-helden-shared/client/theme/fonts';
import { fontReset } from '@adornis/fonts/font-resets.js';
import { XText } from '@adornis/fonts/fonts';
import { customElement } from 'lit/decorators.js';

setGlobalStyle(() => ({
  em: {
    fontStyle: 'unset',
    letterSpacing: '1px',
    fontFamily: DigitaleHeldenFont.REGULAR_ITALIC,
  },
  'd-h1 em': {
    fontFamily: DigitaleHeldenFont.BLACK_ITALIC,
  },
}));

@customElement('d-text')
export class DText extends XText {
  override styles() {
    return [
      fontReset(DigitaleHeldenFont.REGULAR, 1, 400, 1.5556, 18),
      {
        '&[large]': { fontSize: '20px' },
        '&[small]': { fontSize: '14px' },
        '&[font-black]': { fontFamily: DigitaleHeldenFont.BLACK },
        '&[color-grey]': { color: this.colors.tone.secondaryText },
        '&[color-dark-grey]': { color: this.colors.tone.darkGrey },
      },
    ] as Styles[];
  }
}
